import cx from 'classnames';
import React from 'react';
import { MenuItem } from 'react-contextmenu';
import { cssClasses } from 'react-contextmenu/es6/helpers';
import InfoBubble from '../infoBubble/infoBubble';

/**
 * Remove onTouchEnd event handler
 *
 * Also takes `info`: a node shown in an (i) at the end of the item. The (i)
 * stops its click, so reading the bubble neither fires the item nor closes
 * the menu. Pass `infoLabel` for what a screen reader calls it.
 */
export default class FadilaMenuItem extends MenuItem {
  render() {
    const { attributes, children, className, disabled, divider, selected, info, infoLabel } =
      this.props;

    const menuItemClassNames = cx(className, cssClasses.menuItem, attributes.className, {
      [cx(cssClasses.menuItemDisabled, attributes.disabledClassName)]: disabled,
      [cx(cssClasses.menuItemDivider, attributes.dividerClassName)]: divider,
      [cx(cssClasses.menuItemSelected, attributes.selectedClassName)]: selected,
    });

    return (
      <div
        {...attributes}
        className={menuItemClassNames}
        role="menuitem"
        tabIndex="-1"
        aria-disabled={disabled ? 'true' : 'false'}
        aria-orientation={divider ? 'horizontal' : null}
        ref={(ref) => {
          this.ref = ref;
        }}
        onMouseMove={this.props.onMouseMove}
        onMouseLeave={this.props.onMouseLeave}
        onClick={this.handleClick}
      >
        {divider ? null : children}
        {!divider && info && (
          <InfoBubble align="right" label={infoLabel}>
            {info}
          </InfoBubble>
        )}
      </div>
    );
  }
}
